import { render, staticRenderFns } from "./commonTree.vue?vue&type=template&id=54e7984c&scoped=true"
import script from "./commonTree.vue?vue&type=script&lang=js"
export * from "./commonTree.vue?vue&type=script&lang=js"
import style0 from "./commonTree.vue?vue&type=style&index=0&id=54e7984c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7984c",
  null
  
)

export default component.exports